export class EmailTemplateModel {
  id: number;
  displayName: string;
  name: string;
  description: string;
  template: string;
  subject: string;
  isDefault: boolean;
  productId: number;
  productName: string;
}
